'use client';

import React from 'react';

export default function PlayerKycDetailsContent(): React.JSX.Element | null {
  // const [playerData, setPlayerData] = useState<Player>();

  // const { drawerState } = useAppSelector(getUi);
  // const { KYC_DETAILS: data } = useAppSelector(getDrawerContent);

  // const fetchPlayerData = async (): Promise<void> => {
  //   try {
  //     const response = await fetch(`/api/players`, {
  //       method: 'post',
  //       body: JSON.stringify({ playerId: data?.playerId, playerCode: data?.playerCode }),
  //     });
  //     const result: ServiceResponse<Player> = await response.json();
  //     if (response.ok && result.success && result.data) {
  //       setPlayerData(result.data);
  //     }
  //   } catch (e) {
  //     // empty block
  //   }
  // };

  // useEffect(() => {
  //   if (drawerState.PLAYER_DETAILS) void fetchPlayerData();
  // }, [data]);

  return <>Coming Soon</>;
}
